import {
  Button,
  DialogActions,
  DialogContent,
  TextField,
  CircularProgress,
} from "@material-ui/core";
import { KisshtDialog } from "components/custom/KisshtDialog";
import Spin from "components/ui/Spin";
import React, { useEffect, useState } from "react";

export default function ConfirmPassword({
  visible,
  handleClose,
  handleConfirm,
}) {
  const [password, setPassword] = useState("");
  const [touched, setTouched] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSubmit = async () => {
    setTouched(true);
    if (password.trim() === "") return;
    setLoading(true);
    try {
      await handleConfirm(password);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!visible) {
      setPassword("");
      setTouched(false);
      setLoading(false);
    }
  }, [visible]);

  return (
    <Spin>
      <KisshtDialog
        open={visible}
        title="Confirm Password"
        handleClose={handleClose}
        maxWidth="sm"
      >
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Password"
            type="password"
            fullWidth
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            error={touched && password === ""}
            helperText={
              touched && password === "" ? "Password is required" : " "
            }
            autoComplete="new-password"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="contained" disabled={loading}>
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={onSubmit}
            disabled={loading}
          >
            {loading ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              "Submit"
            )}
          </Button>
        </DialogActions>
      </KisshtDialog>
    </Spin>
  );
}
